import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create organizationLocation API
const organizationAPI= createApi({
    reducerPath:"organizationAPI",
    baseQuery:customFetchBase,
    endpoints:(builder)=>({
        // Organization Location Endpoints

        // Query to get all organization location
        getAllOrganizationLocation:builder.query({
            query:()=>({
                url:"/OrganizationLocation/GetAllOrganizationLocation",
                method:"GET"
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Add orgnization location
         addOrganizationLocation: builder.mutation({
            query:(data) => ({
                url: `OrganizationLocation/AddOrganizationLocation`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Delete organization location
        deleteOrganizationLocation:builder.mutation({
            query:(LocationId)=>({
                url:`/OrganizationLocation/DeleteOrganizationLocation?id=${LocationId}`,
                method:'DELETE',
                body:transformRequest(LocationId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        // Query to get organization location
        getOrganizationLocationById: builder.query({
            query: (LocationId) => ({
                url: `OrganizationLocation/GetOrganizationLocationById/?LocationId=${Number(LocationId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // update organization location
        updateOrganizationLocation: builder.mutation({
            query: (data) => ({
                url: '/OrganizationLocation/UpdateOrganizationLocationById',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Query to get organization MailConfig
        getOrgMailConfigByOrganizationId: builder.query({
            query: (OrganizationId) => ({
                 url: `OrganizationMailConfig/GetOrgMailConfigByOrganizationId/?OrganizationId=${Number(OrganizationId)}`,
                Method: 'GET'
             }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Addupdate organization MailConfig
        addUpdateOrganizationMailConfig: builder.mutation({
            query: (data) => ({
                url: '/OrganizationMailConfig/AddUpdateOrganizationMailConfig',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //OrganizationWorkSchedule API
        // Query to get OrganizationWorkSchedule by organizationId
        getOrganizationWorkScheduleByOrgId: builder.query({
            query: (OrganizationId) => ({
                url: `/OrganizationWorkSchedule/GetOrganizationWorkScheduleByOrganizationId/?OrganizationId=${Number(OrganizationId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //AddEdit Organization WorkSchedule 
        AddEditOrganizationWorkSchedule : builder.mutation({
            query: (data) => ({
                url: 'OrganizationWorkSchedule/AddEditOrganizationWorkSchedule',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse : transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
            updateOrganizationById : builder.mutation({
            query: (data) => ({
                url: '/Organization/UpdateOrganizationById',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse : transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getOrganizationById: builder.query({
            query: (OrganizationId) => ({
                url: `/Organization/GetOrganizationById/?OrganizationId=${Number(OrganizationId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
});

// Extract hooks for easy access to various API requests 
 export const { 
    useLazyGetAllOrganizationLocationQuery, 
    useAddOrganizationLocationMutation,
    useDeleteOrganizationLocationMutation , 
    useLazyGetOrganizationLocationByIdQuery,
    useUpdateOrganizationLocationMutation,
    useLazyGetOrgMailConfigByOrganizationIdQuery,
    useAddUpdateOrganizationMailConfigMutation,
    useLazyGetOrganizationWorkScheduleByOrgIdQuery,
    useAddEditOrganizationWorkScheduleMutation,
    useUpdateOrganizationByIdMutation,
    useLazyGetOrganizationByIdQuery
} = organizationAPI;

export default organizationAPI;